export function formatIndianCurrency(num: number): string {
  if (!num) return '0';

  const sign = num < 0 ? '-' : '';
  const abs = Math.abs(num);

  if (abs >= 10000000) {
    return sign + (abs / 10000000).toFixed(2).replace(/\.00$/, '') + ' Cr';
  }
  if (abs >= 100000) {
    return sign + (abs / 100000).toFixed(2).replace(/\.00$/, '') + ' L';
  }
  if (abs >= 1000) {
    return sign + (abs / 1000).toFixed(2).replace(/\.00$/, '') + ' K';
  }
  return sign + abs.toString();
}

/** Prefer Crores; if too small to show meaningfully as Cr (< 0.01 Cr / ₹1L), use L/K/rupees. */
export function formatPreferCrores(num: number): string {
  if (!num) return '0 Cr';
  const sign = num < 0 ? '-' : '';
  const abs = Math.abs(num);
  const cr = abs / 10000000;
  if (cr >= 0.01) {
    return `${sign}${cr.toFixed(2).replace(/\.00$/, '')} Cr`;
  }
  return formatIndianCurrency(num);
}
